import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import BlockVerticalAlignmentUI from './ui';

const BlockVerticalAlignmentControl = props => {
  return createElement(BlockVerticalAlignmentUI, _extends({}, props, {
    isToolbar: false
  }));
};

const BlockVerticalAlignmentToolbar = props => {
  return createElement(BlockVerticalAlignmentUI, _extends({}, props, {
    isToolbar: true
  }));
};
/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/block-vertical-alignment-control/README.md
 */


export { BlockVerticalAlignmentControl, BlockVerticalAlignmentToolbar };
//# sourceMappingURL=index.js.map